export const USER_COLS = [
  'Name',
  'Email',
  'Role',
  'Status'
]

export const USER_COL_WIDTHS = [250, 300, 400, 250]

export const HEADER_NAME_MAP = {
  'Name': "name",
  'Email': "email",
  'Role': "role",
  'Status': 'status',
}

export const SORT_NAME_MAP = {
  'Name': "first_name",
  'Email': "email",
  'Role': "role",
  'Status': 'status',
}